__turbopack_context__.v({
  "highlight": "Highlight-module-scss-module__d-n2WW__highlight",
  "highlight__controls": "Highlight-module-scss-module__d-n2WW__highlight__controls",
  "highlight__controls_kabob": "Highlight-module-scss-module__d-n2WW__highlight__controls_kabob",
  "highlight__video_playing": "Highlight-module-scss-module__d-n2WW__highlight__video_playing",
  "highlight_badge": "Highlight-module-scss-module__d-n2WW__highlight_badge",
  "highlight_block__description": "Highlight-module-scss-module__d-n2WW__highlight_block__description",
  "highlight_explore_the_show": "Highlight-module-scss-module__d-n2WW__highlight_explore_the_show",
  "highlight_first_title": "Highlight-module-scss-module__d-n2WW__highlight_first_title",
  "highlight_logo": "Highlight-module-scss-module__d-n2WW__highlight_logo",
  "highlight_poster": "Highlight-module-scss-module__d-n2WW__highlight_poster",
  "highlight_poster__image": "Highlight-module-scss-module__d-n2WW__highlight_poster__image",
  "highlight_second_title": "Highlight-module-scss-module__d-n2WW__highlight_second_title",
  "highlight_summary": "Highlight-module-scss-module__d-n2WW__highlight_summary",
  "highlight_text": "Highlight-module-scss-module__d-n2WW__highlight_text",
});
